import { merge } from '../../helper';

import * as exTableContent from '../../content/table';
import * as exDatatableContent from '../../content/datatable';

import * as exRequest from '../../utils/request';

// ----------------------------------------------------------------------------

function manager(element: HTMLElement, config: Record<string, any> = {}): Record<string, any> {
    // Source
    const src: Record<string, any> = {
        element: element,
        data: [],
        rowCount: 0,
        columnCount: 0,
        config: {
            ajaxInit: true,
        },
    };

    // ------------------------------------------------------------------------

    function init(): void {
        merge(src.config, config);

        // --------------------------------------------------------------------

        //
        progress();

        // If using ajax
        if (src.config.ajax?.url) {
            ajax.request();
        }

        //
        refresh();
    }

    function progress(): void {
        //
        if (config.data) {
            src.data = config.data;
            src.config.data = config.data;
        }

        // Get count
        const count = exTableContent.getCount(src.element);

        // Set row count
        src.rowCount = count.rowCount;
        // Set column count
        src.columnCount = count.columnCount;
    }

    // ------------------------------------------------------------------------

    function getTableWrapper(): HTMLElement | null {
        return src.element.closest('.table-wrapper');
    }

    function getTable(): HTMLElement {
        return src.element;
    }

    function getElement(): HTMLElement {
        return src.element.closest('.table-wrapper') ?? src.element;
    }

    // ------------------------------------------------------------------------

    const data = (function (): any {
        function get(): any[] {
            return src.data;
        }

        function update(arr: any[]): void {
            src.data.push(...arr);
        }

        function restore(arr: any[]): void {
            src.data = arr;
        }

        // --------------------------------------------------------------------

        return {
            get,
            update,
            restore,
        };
    })();

    const rows = (function (): any {
        function get(id: number): Record<string, any> | undefined {
            // Get element (tbody)
            const elTableBody = src.element.querySelector('tbody');

            // If there is no rows
            if ((elTableBody?.rows?.length ?? 0) === 0) {
                console.error('Not found rows...');
                return;
            }

            // Get element (row)
            const rowElement = elTableBody.rows[id];
            // Get data
            const rowData = src.data[id];

            // Return
            return {
                element: rowElement,
                data: rowData,
            };
        }

        function add(config: Record<string, any> = {}): void {
            // Operation Start
            exDatatableContent.operation.start(src.element, {
                merge: config,
            });

            // Foreach Data
            for (const item of config.data) {
                data.update(item);
            }

            // Refresh
            refresh();
        }

        // --------------------------------------------------------------------

        return {
            get,
            add,
        };
    })();

    const ajax = (function (): any {
        function request(): void {
            // If using ajax init
            if (src.config.ajaxInit === true) {
                reload();
            }
        }

        function reload(): void {
            // Settings
            const settings: Record<string, any> = {};

            // Object assign
            Object.assign(settings, src.config.ajax);

            // ----------------------------------------------------------------

            // If using function data
            if (typeof settings.data === 'function') {
                const obj = {};

                // Function Data
                settings.data(obj);

                // Object assign
                Object.assign(settings.data, obj);
            }

            // Request Ajax
            exRequest.ajax(settings);
        }

        // --------------------------------------------------------------------

        return {
            request,
            reload,
        };
    })();

    // ------------------------------------------------------------------------

    function refresh(): any {
        // Clear
        exTableContent.clear(src.element, src.config);

        // If there is data
        if ((src.data?.length ?? 0) > 0) {
            //
            src.config.data = src.data;

            // Operation Start
            exDatatableContent.operation.start(src.element, src.config);
        }

        /*
         *  Return
         * return this;
         */
    }

    function clear(): any {
        src.data = [];

        // Clear
        exTableContent.clear(src.element, src.config);

        /*
         *  Return
         * return this;
         */
    }

    // ------------------------------------------------------------------------

    function resize(): any {
        // Resize Scroll
        exTableContent.resize.scroll(src.element);

        /*
         *  Return
         * return this;
         */
    }

    // ------------------------------------------------------------------------

    init(); // Ready

    return {
        element,
        src,
        getTableWrapper,
        getTable,
        getElement,
        data,
        rows,
        ajax,
        refresh,
        clear,
        resize,
    };
}

// ----------------------------------------------------------------------------

export default manager;
